export default __webpack_public_path__ + "8fcb348ddfe1ffdd2eb5bf49c4229a76.png";